import { MatchMedia } from '@helvetia/components/MatchMedia'
import Text from '@helvetia/components/Text'
import * as H from 'history'
import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'

import { eventEmitter } from '../core'
import { Events as ApiClientEvents } from '../core/infraestructure/apiClient'
import { Modal } from './_components/Modal'
import { NotAllowed } from './NotAllowed'
import { NotAuthorized } from './NotAuthorized'
import { NotFound } from './NotFound'

const errorPages = {
  '401': <NotAuthorized />,
  '403': <NotAllowed />,
  '404': <NotFound />,
}

interface State {
  hasError: boolean
  errorCode: string
}

interface Props {
  history: H.History
}

class GlobalErrorHandler extends React.Component<
  Props & WithNamespaces,
  State
> {
  state = {
    hasError: false,
    errorCode: '',
  }

  removeError401Listener: Function
  removeError403Listener: Function
  removeError404Listener: Function

  componentDidMount() {
    this.removeError401Listener = eventEmitter.on(
      ApiClientEvents.ERROR_401,
      () => {
        console.log('ERROR 401')
        this.setState({ hasError: true, errorCode: '401' })
      },
    )

    this.removeError403Listener = eventEmitter.on(
      ApiClientEvents.ERROR_403,
      () => {
        console.log('ERROR 403')
        this.setState({ hasError: true, errorCode: '403' })
      },
    )

    this.removeError404Listener = eventEmitter.on(
      ApiClientEvents.ERROR_404,
      () => {
        console.log('ERROR 404')
        this.setState({ hasError: true, errorCode: '404' })
      },
    )
  }
  componentWillUnmount() {
    this.removeError401Listener()
    this.removeError403Listener()
    this.removeError404Listener()
  }

  render() {
    const { t } = this.props
    const { errorCode } = this.state

    if (!this.state.hasError) {
      return this.props.children
    }

    const errorPage = errorPages[errorCode]
    if (!errorPage) {
      throw new Error('error code not recognize')
    } else if (
      errorCode === '401' &&
      this.props.history.location.pathname.includes('/login')
    ) {
      return (
        <Modal
          buttonText={t('buttons.accept')}
          onClose={() => location.reload()}
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{t('modal.login.title')}</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{t('modal.login.title')}</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="m" as="p" color="black">
            {t('modal.login.p1')}
          </Text>
        </Modal>
      )
    } else {
      return errorPage
    }
  }
}

export default withNamespaces()(GlobalErrorHandler)
